import axios from 'axios';
import { auth } from '@/lib/firebase';

// Remove trailing slash from REACT_APP_BACKEND_URL to prevent double-slash URLs
const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
const API_URL = `${BASE}/api`;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(async (config) => {
  const currentUser = auth.currentUser;
  if (currentUser) {
    // Always get a fresh Firebase ID token (auto-refreshes if expired)
    const token = await currentUser.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // Fallback: legacy JWT from localStorage
    const token = localStorage.getItem('virtu_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('virtu_token');
      localStorage.removeItem('virtu_user');
      if (!auth.currentUser) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
